import Http from '../http';

const prefix = '/heat-map';

export const auth = (id, language) => {
  return Http.authApi().post(`${prefix}/auth`, {id, language});
};

export const createHeatMap = (params) => {
  return Http.authApi().post(`${prefix}/register`, params);
};

export const hasWithURL = (params) => {
  return Http.authApi().post(`${prefix}/has-with-url`, params);
};

export const updateURL = (params) => {
  return Http.authApi().post(`${prefix}/update-url`, params);
};

export const checkHeatMap = (params) => {
  return Http.authApi().post(`${prefix}/get`, params);
};



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/heatMap.js